import { render, staticRenderFns } from "./BaseFormToggleWithInput.vue?vue&type=template&id=ba882470&scoped=true"
import script from "./BaseFormToggleWithInput.vue?vue&type=script&lang=js"
export * from "./BaseFormToggleWithInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba882470",
  null
  
)

export default component.exports